export default "__VITE_ASSET__BzAJNF8___"